import { useCallback, useEffect, useRef, useState } from "react";

export const useDebouncedKeywordState = (debounceMs: number = 500) => {
  const [keyword, setKeyword] = useState("");
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const schedule = useCallback(
    (raw: string) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setKeyword(raw.trim()), debounceMs);
    },
    [debounceMs],
  );

  const reset = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setKeyword("");
  }, []);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return { keyword, schedule, reset };
};
